export default __webpack_public_path__ + "8b4fc9bc6210234798a09098472f9a79.svg";